import { ExplorationsActionType } from '~/actions/exploration/explorations.actions';
import { AppStore } from '~/types/main.types';

import { ExplorationService } from '@mode/shared/data-access-webapp';

export class ExplorationsIndexViewDataService {
  static $inject = ['RxStoreService', 'ExplorationService'];

  constructor(private store: AppStore, private explorationService: ExplorationService) {}

  deleteExploration(organizationName: string, explorationToken: string) {
    return this.explorationService.deleteExploration(organizationName, explorationToken).then((response: any) => {
      this.store.dispatch({
        type: ExplorationsActionType.DeleteExplorationSuccess,
        explorationToken: explorationToken,
      });
    });
  }

  loadAllExplorations(organizationName: string, username: string) {
    return this.explorationService.loadExplorations(organizationName, username).then((response: any) => {
      this.store.dispatch({
        type: ExplorationsActionType.LoadAllExplorations,
        explorations: response._embedded.explorations,
      });
    });
  }
}
